import { render } from "./InvoicesMenu.vue?vue&type=template&id=3d507326&scoped=true"
import script from "./InvoicesMenu.vue?vue&type=script&lang=js"
export * from "./InvoicesMenu.vue?vue&type=script&lang=js"

import "./InvoicesMenu.vue?vue&type=style&index=0&id=3d507326&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d507326"]])

export default __exports__